class Utils {
    static getALLImagePath(imageName, position) {
        if (!imageName || !position) {
            console.warn('文件名或位置不能为空！')
        }
       let  publicPath = process.env.BASE_URL

        return {
            showImage: `/image/${position}/show/${imageName}`,
            smallImage: `/image/${position}/small/${imageName}`,
            realImage: `../../image/${position}/original/${imageName}`,
        }
    }
}

export {Utils}
